<template>
  <div id="Planning-booking">

    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col >
          <h1 class="labelBold">{{ this.$t(`bookingTransport.planning.title`) }}</h1>
        </b-col>
      </b-row>
      <br/>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">
        <b-col sm="2" lg="2" style="background-color:white;">
          <div v-if="ocultar">

          </div>
          <div v-else>
            <div class="public-checkbox">
              <input type="checkbox" id="public-checkbox" v-model="checkmassive" @click="PrePlaneacionClick()"/>
              <label for="public-checkbox">{{ $t("bookingTransport.planning.massivePlanning") }}</label>
            </div>

          </div>
        </b-col>

        <b-col sm="2" lg="2" style="background-color:white;">
          <div class="dateInput">
            <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_from") }}</label>
            <br>
            <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
            </date-picker>
            <div v-if="$v.dates.from.$error" class="error-msg">
              <p v-if="!$v.dates.from.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_from")}}{{$t("bookingTransport.required")}}</p>
              <p v-if="!$v.dates.from.InvalidDate">{{$t("bookingTransport.planning.notCreatePlanning")}}</p>
            </div>
          </div>
        </b-col>

        <b-col sm="2" lg="2"  style="background-color:white;">
          <div class="dateInput">
            <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_to") }}</label>
            <br>
            <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
            </date-picker>
            <div v-if="$v.dates.to.$error" class="error-msg">
              <p v-if="!$v.dates.to.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_to")}}{{$t("bookingTransport.required")}}</p>
            </div>
          </div>
        </b-col>
        <b-col sm="2" lg="2"  style="background-color:white;">
          <div class="">
            <label class="labelBold mt-2">
              {{ $t("bookingTransport.planning.blockedSeats")}}
            </label>
            <input type="number" v-model="blockedSeats"/>
            <div v-if="$v.blockedSeats.$error" class="error-msg">
              <p v-if="!$v.blockedSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
            </div>
          </div>
        </b-col>
        <b-col sm="2" lg="2"  style="background-color:white;">
          <div class="noEditable">
            <label class="labelBold mt-2">
              {{ $t("bookingTransport.planning.availableSeats")}}
            </label>
            <input class="noEditable"  type="number" v-model="availableSeats" disabled/>
            <div v-if="$v.availableSeats.$error" class="error-msg">
              <p v-if="!$v.availableSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
            </div>
          </div>
        </b-col>
        <b-col sm="2" lg="2"  style="background-color:white;">
          <div class="">
            <label class="labelBold mt-2">
              {{ $t("bookingTransport.planning.capacity")}}
            </label>
            <input type="number" v-model="capacity"/>
            <div v-if="$v.capacity.$error" class="error-msg">
              <p v-if="!$v.capacity.ids">{{ $t("bookingTransport.mayor")}}</p>
            </div>
          </div>
        </b-col>
      </b-row>
      <br/>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12" style="background-color:red;">
        <b-col sm="4" lg="4" style="background-color:white;">
          <label class="black">{{ $t("bookingTransport.planning.schedule") }}</label>
          <input class="form-control" type="text" id="schedule" v-model="filterSchedule" placeholder="Filter Schedule.." @keyup="getSchedule" />
          <select class="form-control" v-model="idSchedule" id="schedule" @change="showSetStops">
            <option value="0" disabled>{{ $t("bookingTransport.select")}}</option>
            <option v-for="data in arraySchedule" :key="data.id" :value="data.id" v-text="data.shift_name"></option>
          </select>
          <div v-if="$v.idSchedule.$error" class="error-msg">
            <p v-if="!$v.idSchedule.ids">{{ $t("bookingTransport.selectRoute")}}</p>
          </div>
        </b-col>
        <b-col sm="4" lg="4" style="background-color:white;">
          <div v-if="massive">
          </div>
          <div v-else>
            <label class="black">{{ $t("bookingTransport.planning.route") }}</label>
            <input class="form-control" type="text" id="routes" v-model="filterRoutes" placeholder="Filter routes.." @keyup="getRoutes" />
            <select class="form-control" v-model="idRoute" id="routes" @change="showSetStops">
              <option value="0" disabled>{{ $t("bookingTransport.select")}}</option>
              <option v-for="data in arrayRutas" :key="data.id" :value="data.id" v-text="data.route_name"></option>
            </select>
          </div>
        </b-col>
        <b-col sm="2" lg="2"  style="background-color:white;">
          <div v-if="massive">
          </div>
          <div v-else>
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.platform")}}
              </label>
              <input type="number" v-model="idPlatform"/>
            </div>
          </div>
        </b-col>
        <b-col sm="2" lg="2"  style="background-color:white;">
          <div v-if="checkmassive">
            <button class="btn-confirm btn-outline-secondary" @click="PrePlanning">
              {{ $t("bookingTransport.planning.prePlanning") }}
              <i style='font-size:18px' class='fas'>&#xf03a;</i>
            </button>
          </div>
          <div v-if="PlanningGenerate">
            <button class="btn-confirm btn-outline-secondary" @click="SavePlanning">
              {{ $t("bookingTransport.planning.createPlanning") }}
              <i style='font-size:18px' class='fas'>&#xf0c7;</i>
            </button>
          </div>
          <div v-if="PlanningGenerateMassive">
            <button class="btn-confirm btn-outline-secondary" @click="SavePrePlanning">
              {{ $t("bookingTransport.CreateMassive") }}
              <i style='font-size:18px' class='fas'>&#xf0c7;</i>
            </button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <br/>
    <div v-if="massive" class="row">
      <div class="col-md-12">
        <v-client-table :data="ArrayPrePlanning" :columns="table_options_preplanning.columns" :options="table_options_preplanning.options" ref="PrePlanningTable" id="PrePlanningTable">
          <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
          <template #shift="props">{{ translateShift(props.row.shift)}} </template>
          <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{props.row.IdsError}} </div></template>
          <template v-slot:actions="props">
            <center>
              <i style='font-size:.9rem' class='fa btn btn-outline-secondary' @click="ModifyPrePlanning(props.row,false)">&#xf044;</i>
            </center>
          </template>
          <template v-slot:eliminar="props">
            <center>
              <i style='font-size:.9rem' class='fa btn btn btn-outline-danger' @click="ModifyPrePlanning(props.row,true)">&#xf1f8;</i>
            </center>
          </template>
          <div slot="filter__route_id">
            <select class="form-control" name="route_id" id ="route_id" v-model="selected" @change="filterStatus(selected)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arrayRutas"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.route_name }}
              </option>
            </select>
          </div>
          <div slot="filter__shift">
            <select class="form-control" name="shift" id ="shift" v-model="selectedIdTurno" @change="filterShift(selectedIdTurno)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arraySchedule"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.shift_name }}
              </option>
            </select>
          </div>
        </v-client-table>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-12" v-if="tableData">
          <v-client-table :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options" ref="PlanningStops" id="PlanningStops">
            <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{"Error"}} </div></template>
            <template #schedule="props">{{ props.row.schedule }}</template>
            <template v-slot:edit="props">
              <center>
                <i style='font-size:.9rem' class='fa btn btn-outline-secondary' @click="ModifyStops(props.row,false)">&#xf044;</i>
              </center>
            </template>
            <template v-slot:remove="props">
              <center>
                <i style='font-size:.9rem' class='fa btn btn-outline-danger' @click="ModifyStops(props.row,true)">&#xf1f8;</i>
              </center>
            </template>
            <button
              class="btn-AddStops btn-outline-secondary"
              slot="beforeLimit"
              type="primary"
              @click="AddRoutes">
              {{$t('bookingTransport.AddStops')}}
            </button>
          </v-client-table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-server-table :columns="table_options.columns" :options="table_options.options" ref="planningTable" id="planningTable">
          <template #created_at="props">{{props.row.created_at | formatDateOnly(appLang)}}</template>
          <template #period_from="props">{{props.row.period_from | formatDateOnly(appLang)}}</template>
          <template #period_to="props">{{props.row.period_to | formatDateOnly(appLang)}}</template>
          <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
          <template #shift="props">{{ translateShift(props.row.shift)}} </template>
          <template v-slot:actions="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyPrePlanning(props.row,false,'planning')">&#xf044;</i>
            </center>
          </template>
          <div slot="filter__route_id">
            <select class="form-control" name="route_id" id ="route_id" v-model="selected" @change="filterStatusP(selected)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arrayRutas"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.route_name }}
              </option>
            </select>
          </div>
          <div slot="filter__shift">
            <select class="form-control" name="shift" id ="shift" v-model="selectedIdTurno" @change="filterShiftP(selectedIdTurno)">
              <option value="0">{{$t('bookingTransport.select')}} </option>
              <option v-for="option in arraySchedule"
                      v-bind:key="option.id"
                      v-bind:value="option.id">
                {{option.shift_name }}
              </option>
            </select>
          </div>
          <div slot="filter__created_at">
            <date-picker  id="created_at" name="created_at" @change="filterCreate(Filter_created_at)"  v-model="Filter_created_at"
                          placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <div slot="filter__period_from">
            <date-picker  id="period_from" name="period_from" @change="filterFrom(Filter_period_from)"  v-model="Filter_period_from"
                          placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <div slot="filter__period_to">
            <date-picker  id="period_to" name="period_to" @change="filterTo(Filter_period_to)"  v-model="Filter_period_to"
                          placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
            </date-picker>
          </div>
          <template v-slot:enabled="props">
            <input
              disabled
              type="checkbox"
              :name="`select${props.row.id}`"
              :id="`select${props.row.id}`"
              :value="props.row.id"
              v-model="props.row.enabled"/>
          </template>
          <template v-slot:carritochk="props">
            <input v-if="props.row.enabled"
                   type="checkbox"
                   :name="`select${props.row.id}`"
                   :id="`select${props.row.id}`"
                   :value="props.row"
                   v-model="carrito"
                   @click="chkMassive(props.row,$event)"/>
          </template>
          <button v-if="carrito.length>0"
                  class="btn-AddStops btn-outline-secondary"
                  slot="beforeLimit"
                  type="primary"
                  @click="CancelationMassive">
            {{$t('bookingTransport.cancelationMassive')}}
          </button>
        </v-server-table>
      </div>
    </div>
    <b-modal size="lg" centered ref="my-edit" no-close-on-backdrop  :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100" v-if="DeleteStop">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.delete')}}</p>
          </h3>
        </div>
        <div class="w-100" v-else>
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.edit')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3" v-if="DeleteStop">
          <b-col sm="1" >
            <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
          </b-col>
          <b-col sm="11">
            <h4 class="labelBold">{{ $t("bookingTransport.planning.confirmDelete") }}</h4>
          </b-col>
        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="4" class="noEditable">
            <label class="labelBold">{{ $t("bookingTransport.planning.schedule") }}</label>
            <input type="text" v-model="ScheduleValidate.shift_name" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.start_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.start_time" disabled></vue-timepicker>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.Schedule.tableSchedule.headings.end_time") }}</label>
            <vue-timepicker class="noEditable" v-model="ScheduleValidate.end_time" disabled></vue-timepicker>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="4" class="noEditable">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.id") }}</label>
            <input type="text" v-model="id_parada" disabled/>
          </b-col>
          <b-col sm="4" class="noEditable">
            <label class="labelBold">{{ $t("bookingTransport.planning.TableStops.headings.stop_name") }}</label>
            <input type="text" v-model="stop_name" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.planning.TableStops.headings.schedule") }}</label>
            <vue-timepicker v-model="schedule"></vue-timepicker>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirm()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEdit()">
            {{$t("bookingTransport.cancel")}}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal style="z-index:-1" size="xl" centered ref="Pre-Planning-edit" no-close-on-backdrop  :title="$t('bookingTransport.edit')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100" v-if="DeleteRowPreplanning">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.deletePreplannign')}}</p>
          </h3>
        </div>
        <div class="w-100" v-else>
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.planning.editPreplannign')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3" v-if="DeleteRowPreplanning">
          <b-col sm="1" >
            <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
          </b-col>
          <b-col sm="11">
            <h4 class="labelBold">{{ $t("bookingTransport.planning.confirmDeletePreplanning") }}</h4>
          </b-col>
        </b-row>
        <b-row cols="1" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="3" lg="3" >
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_from") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.from.$error" class="error-msg">
                <p v-if="!$v.dates.from.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_from")}}{{$t("bookingTransport.required")}}</p>
                <p v-if="!$v.dates.from.InvalidDate">{{$t("bookingTransport.planning.notCreatePlanning")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="3" lg="3" >
            <div class="dateInput">
              <label class="black">{{ $t("bookingTransport.planning.TablePlanning.headings.period_to") }}</label>
              <br>
              <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY-MM-DD" value-type="format" format="YYYY-MM-DD" >
              </date-picker>
              <div v-if="$v.dates.to.$error" class="error-msg">
                <p v-if="!$v.dates.to.required">{{$t("bookingTransport.planning.TablePlanning.headings.period_to")}}{{$t("bookingTransport.required")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2" >
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.blockedSeats")}}
              </label>
              <input type="number" v-model="blockedSeats" />
              <div v-if="$v.blockedSeats.$error" class="error-msg">
                <p v-if="!$v.blockedSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2">
            <div class="noEditable">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.availableSeats")}}
              </label>
              <input class="noEditable"  type="number" v-model="availableSeats" disabled/>
              <div v-if="$v.availableSeats.$error" class="error-msg">
                <p v-if="!$v.availableSeats.sits_val">{{ $t("bookingTransport.errorCapacity")}}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="2" lg="2">
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.capacity")}}
              </label>
              <input type="number" v-model="capacity"/>
              <div v-if="$v.capacity.$error" class="error-msg">
                <p v-if="!$v.capacity.ids">{{ $t("bookingTransport.mayor")}}</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <br/>
        <b-row cols="0" cols-sm="1" cols-md="2" cols-lg="3">
          <b-col sm="3">
            <label class="black">{{ $t("bookingTransport.planning.schedule") }}</label>
            <select class="form-control" v-model="idSchedule" id="schedule" @change="showSetStops" disabled>
              <option value="0" disabled> {{$t('bookingTransport.select')}}</option>
              <option v-for="data in arraySchedule" :key="data.id" :value="data.id" v-text="data.shift_name"></option>
            </select>
            <div v-if="$v.idSchedule.$error" class="error-msg">
              <p v-if="!$v.idSchedule.required">{{$t("bookingTransport.Stops.TableStops.headings.route_idrequired")}}</p>
            </div>
          </b-col>
          <b-col sm="3">
            <label class="black">{{ $t("bookingTransport.planning.route") }}</label>
            <select class="form-control" v-model="idRoute" id="routes" @change="showSetStops" disabled>
              <option value="0" disabled> {{$t('bookingTransport.select')}}</option>
              <option v-for="data in arrayRutas" :key="data.id" :value="data.id" v-text="data.route_name"></option>
            </select>
          </b-col>
          <b-col sm="3">
            <div class="">
              <label class="labelBold mt-2">
                {{ $t("bookingTransport.planning.platform")}}
              </label>
              <input type="number" v-model="idPlatform"/>
            </div>
          </b-col>
          <b-col sm="2" lg="2" >
            <input type="checkbox" id="enablePlanning-checkbox" v-model="EnablePlanning"/>
            <!-- <label for="public-checkbox">{{ $t("bookingTransport.planning.period") }}</label> -->
            <label for="enablePlanning-checkbox"> {{$t('bookingTransport.Enable')}}</label>
          </b-col>
        </b-row>
        <v-client-table :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options" ref="PlanningStops" id="PlanningStops">
          <template #error="props"> <div  style="color:red;" v-if="props.row.error"> {{"Error"}} </div></template>
          <template #schedule="props">{{ props.row.schedule }}</template>
          <template v-slot:edit="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyStops(props.row,false)">&#xf044;</i>
            </center>
          </template>
          <template v-slot:remove="props">
            <center>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="ModifyStops(props.row,true)">&#xf1f8;</i>
            </center>
          </template>
          <button
            class="btn-AddStops btn-outline-secondary"
            slot="beforeLimit"
            type="primary"
            @click="AddRoutes">
            {{$t('bookingTransport.Routes.AddStop')}}
          </button>
        </v-client-table>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirmPrePlanning()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeEditPrePlanning()">
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal size="lg" centered ref="add-Stops" no-close-on-backdrop  :title="$t('bookingTransport.planning.addRoutes')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h3>
            <p class="labelBold float-left">{{$t('bookingTransport.Routes.AddStop')}}</p>
          </h3>
        </div>
      </template>
      <b-container class="bv-example-row">
        <v-client-table :data="arrayAddRutas" :columns="table_optionsAddStops.columns" :options="table_optionsAddStops.options" ref="AddStops" id="AddStops">
          <template #schedule="props">{{ props.row.schedule }}</template>
          <template v-slot:Stopschk="props">
            <input
              type="checkbox"
              :name="`select${props.row.id}`"
              :id="`select${props.row.id}`"
              :value="props.row.id"
              v-model="carritoAdd"
              @click="AddChkStop(props.row,$event)"
            />
          </template>
        </v-client-table>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditAddConfirm()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeAddRoute()">
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal size="lg" centered ref="my-information" no-close-on-backdrop tabindex="-1" >
      <template #modal-header>
        <h3>
          <p class="labelBold float-left">{{ $t("bookingTransport.information") }}</p>
        </h3>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="4">
            <label class="labelBold">{{ $t("bookingTransport.routesCreate") }}</label>
            <input type="text" v-model="PrePlanningCreate" disabled/>
          </b-col>
          <b-col sm="4">
            <label class="black">{{ $t("bookingTransport.routesNoCreate") }}</label>
            <input type="text" v-model="PrePlanningError" disabled/>
          </b-col>
        </b-row>
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <label class="black">{{ $t("bookingTransport.routesCreate") }}</label>
            <input type="text" v-model="RutasCreadas" disabled/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="CloseInformation()">
            {{ $t("bookingTransport.acept") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal style="z-index:1" size="lg" centered ref="my-cancellation" no-close-on-backdrop  :title="$t('bookingTransport.Continue')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h1>
            <p class="labelBold float-left">{{$t('bookingTransport.Continue')}}</p>
          </h1>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <div class="error-msg">
              <h2>{{$t("bookingTransport.planning.Total")}} {{this.arrayCancellation.length}}</h2>
            </div>
          </b-col>
        </b-row>
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <h3>{{$t("bookingTransport.planning.CancellationMessage")}}</h3>
          </b-col>
          <br/>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditMyCancellation()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeMyCancellation()">
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal style="z-index:1" size="xl" centered ref="my-cancellation-massive" no-close-on-backdrop  :title="$t('bookingTransport.Continue')" tabindex="-1" >
      <template #modal-header>
        <div class="w-100">
          <h1>
            <p class="labelBold float-left">{{$t('bookingTransport.Continue')}}</p>
          </h1>
        </div>
      </template>
      <b-container class="bv-example-row">
        <b-row cols="0" cols-sm="4" cols-md="6" cols-lg="12">
          <b-col sm="12">
            <div class="error-msg">
              <h3>{{$t("bookingTransport.planning.CancellationMessageMassive")}}</h3>
            </div>
          </b-col>
          <b-col sm="12">
            <v-client-table :data="arrayCancelationMassive" :columns="table_optionsAddCancelation.columns" :options="table_optionsAddCancelation.options" ref="AddCancelationMassive" id="AddCancelationMassive">
              <template #created_at="props">{{props.row.created_at | formatDateOnly(appLang)}}</template>
              <template #period_from="props">{{props.row.period_from | formatDateOnly(appLang)}}</template>
              <template #period_to="props">{{props.row.period_to | formatDateOnly(appLang)}}</template>
              <template #reservation="props"> <div class="error-msg"> <h3>{{props.row.reservation}}</h3></div> </template>
              <template #route_id="props">{{ translateRoute(props.row.route_id)}} </template>
              <template #shift="props">{{ translateShift(props.row.shift)}} </template>
              <div slot="filter__created_at">
                <date-picker  id="created_at" name="created_at" @change="filterCreate(Filter_created_at)"  v-model="Filter_created_at"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>
              <div slot="filter__period_from">
                <date-picker  id="period_from" name="period_from" @change="filterFrom(Filter_period_from)"  v-model="Filter_period_from"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>
              <div slot="filter__period_to">
                <date-picker  id="period_to" name="period_to" @change="filterTo(Filter_period_to)"  v-model="Filter_period_to"
                              placeholder="YYYY-MM-DD" valueType="YYYY-MM-DD" >
                </date-picker>
              </div>
              <template v-slot:enabled="props">
                <input
                  disabled
                  type="checkbox"
                  :name="`select${props.row.id}`"
                  :id="`select${props.row.id}`"
                  :value="props.row.id"
                  v-model="props.row.enabled"/>
              </template>
            </v-client-table>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            size="lg"
            class="btn btn-dark float-right"
            @click="EditConfirmMassiveCancelation()">
            {{$t('bookingTransport.confirm')}}
          </b-button>
          <b-button
            size="lg"
            class="btn btn-light float-right"
            @click="closeMyCancellationMassive()">
            {{ $t("bookingTransport.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
const ids = (value) => value != 0 && value > 0 ;
import { required, url, decimal } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";
import API_SERVICE from "@/lib/api/Booking.js";
import moment from "moment-timezone";
const api = new API_SERVICE();
import { toMilitaryTime } from '@/lib/utils';

export default {
  components: {
    DatePicker,
    VueTimepicker
  },
  data() {
    return {
      validationPlanning:false,
      validationPlanningMassive:false,
      selected:'',
      selectedIdTurno:'',
      numero:'',
      id_parada:'',
      route_id:'',
      stop_number:'',
      stop_name:'',
      coordenates:'',
      schedule:'',
      DeleteStop:false,
      Filter_created_at:"",
      Filter_period_from:"",
      Filter_period_to:"",
      FinalStops:[],
      carrito:[],
      filterRoutes: '',
      filterSchedule: '',
      filterPlatform:'',
      idRoute:0,
      idSchedule:0,
      idPlatform:0,
      arrayRutas:[],
      arrayAddRutas:[],
      arrayCancelationMassive:[],
      arraySchedule:[],
      arrayPlatform:[],
      arrayCancellation:[],
      carritoAdd:[],
      ValidateScheduleEdit:[],
      ScheduleValidate:{
        shift_name:'',
        start_time:'',
        end_time:''
      },
      IdPlanning:0,
      blockedSeats:0,
      capacity:44,
      tableData: [],
      EditPrePlanning: false,
      EnablePlanning: false,
      period: false ,
      checkmassive:false,
      ocultar:false,
      massive:false,
      PlanningGenerate:true,
      PlanningGenerateMassive:false,
      DeleteRowPreplanning:false,
      PrePlanningCreate:0,
      PrePlanningError:0,
      RutasCreadas:"",
      dates:
        {
          from: null,
          to: null,
        },
      ArrayPrePlanning:[]
    }
  },
  validations: {
    dates: {
      from:{
        required,
        InvalidDate: function(Planning) {
          let fecha = new Date();
          let ValFecha =  moment(fecha).format('YYYY-MM-DD');
          if (Planning >= ValFecha)
          {
            return true;
          }
          else
          {
            return false;
          }

        }
      },
      to: {
        required
      }
    },
    idSchedule:{
      ids
    },
    capacity:{
      ids
    },
    availableSeats:{
      sits_val: function(value) {
        if (Math.floor(value) <= Math.floor(this.capacity))
          return true;
        if (Math.floor(value) >= Math.floor(this.capacity))
          return false;
      },
    },
    blockedSeats:{
      sits_val: function(value) {
        if (Math.floor(value) <= Math.floor(this.capacity))
          return true;
        if (Math.floor(value) >= Math.floor(this.capacity))
          return false;
      },
    },
  },
  beforeMount: async function() {
    this.$store.commit("global/SET_LOADING", true);
    await this.getRoutes();
    await this.getSchedule();
    await this.getPlatform();
    this.$store.commit("global/SET_LOADING", false);
  },
  methods:{
    deleteErrors () {
      this.arrayRutas = this.arrayRutas.filter(ruta => !ruta.error);
    },
    async chkMassive(data,cb)
    {
      if(cb.target.checked)
      {
        this.carrito.push(data);
      }
      else{
        this.carrito = this.carrito.filter((e)=> e !== data )
      }
    },
    UpdateplanningTable: function() {
      this.planningTable.refresh();
    },
    PrePlaneacionClick: function () {
      this.PlanningGenerate = this.checkmassive;
      this.massive = !this.checkmassive;
    },
    translateError (error) {
      if(error==true){
        return "SI";
      }
      else if(error==false){
        return "NO";
      }
    },
    translateRoute (route_id) {
      const description = this.arrayRutas.filter((e)=> e.id == route_id)
      if(description.length>0)
      {
        return description[0].route_name;
      }else
      {
        return route_id;
      }
    },
    translateShift(shift) {
      const description = this.arraySchedule.filter((e)=> e.id == shift)
      if(description.length>0)
      {
        return description[0].shift_name
      }else
      {
        return shift;
      }
    },
    filterShift: function($event)
    {
      if($event == 0){
        this.PrePlanningTable.setFilter({"shift":""});
      }
      else{
        this.PrePlanningTable.setFilter({"shift":$event});
      }
    },
    filterStatus: function($event)
    {
      if($event == 0){
        this.PrePlanningTable.setFilter({"route_id":""});
      }
      else{
        this.PrePlanningTable.setFilter({"route_id":$event});
      }
    },
    filterShiftP: function($event)
    {
      if($event == 0){

        this.selectedIdTurno = 0;
        this.planningTable.setFilter({"shift":""});
      }
      else{
        this.planningTable.setFilter({"shift":$event});
      }
    },
    filterStatusP: function($event)
    {
      if($event == 0){
        this.selected = 0;
        this.planningTable.setFilter({"route_id":""});
      }
      else{
        this.planningTable.setFilter({"route_id":$event});
      }
    },
    filterCreate: function($event)
    {
      this.planningTable.setFilter({"created_at":$event});
    },
    filterFrom: function($event)
    {
      this.planningTable.setFilter({"period_from":$event});
    },
    filterTo: function($event)
    {
      this.planningTable.setFilter({"period_to":$event});
    },
    async AddChkStop(Data,cb)
    {
      try
      {
        if(cb.target.checked)
        {
          const json = {
            id:Data.id,
            route_id:Data.route_id,
            stop_number:Data.stop_number,
            stop_name:Data.stop_name,
            coordenates:Data.coordenates,
            schedule:Data.schedule
          }
          this.carrito.push(json);
        }
        else{
          this.carrito = this.carrito.filter((e)=> e.id !== Data.id)
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
    CancelationMassive: async function()
    {
      try
      {
        this.$store.commit("global/SET_LOADING", true);
        this.arrayCancelationMassive = [];
        for await( const data of this.carrito ) {
          const queries = {};
          queries.planningId =  data.id; //73;
          const resp = await api.Cancellation(queries);
          let json = {
            id:data.id,
            reservation:resp.data.length,
            route_id: data.route_id,
            stops_ids: data.stops_ids,
            platforms_ids: data.platforms_ids,
            availableSeats: data.availableSeats,
            blockedSeats: data.blockedSeats,
            shift: data.shift,
            period_from: data.period_from,
            period_to: data.period_to,
            enabled: false,
            created_at: data.created_at,
            route_description: data.route_description,
            capacity: data.capacity,
            usersCancelation: resp.data
          };
          this.arrayCancelationMassive.push(json)
        }
        this.$refs['my-cancellation-massive'].show();
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
    AddRoutes: async function () {
      if(this.idRoute == 0)  {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg:  `${this.$t("bookingTransport.selectRoute")}`,
          show: true,
          type: "error" });
        return;
      }
      this.$refs['add-Stops'].show();
      try{
        let arrayRutasPre = [];
        this.arrayAddRutas = [];
        this.$store.commit("global/SET_LOADING", true);
        const queries = {};
        queries.catalogType = "stops"
        queries.pagination= {
          all:true,
          limit:300,
          page:1};
        queries.filters = {};
        const resp = await api.getLists(queries);
        resp.data.forEach((data, index) => {
          let queries = {};
          queries.id = data.id
          queries.route_id = data.route_id
          queries.stop_number = data.stop_number
          queries.stop_name = data.stop_name
          queries.coordenates = data.coordenates
          if (data.schedule == null)
          {
            queries.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            queries.schedule = data.schedule[this.idSchedule]
            if(queries.schedule == undefined){
              queries.schedule = "Ninguno"
            }else{
              queries.schedule = data.schedule[this.idSchedule]
            }
          }
          if(queries.schedule.length>=4 && queries.schedule.length<5){
            queries.schedule = "0"+ queries.schedule;
          }
          arrayRutasPre.push(queries);
        });
        this.tableData.forEach((data)=> {
          arrayRutasPre = arrayRutasPre.filter((e)=> e.id !== data.id) });
        this.arrayAddRutas =  arrayRutasPre.sort(function (a, b) {
          let x = a['schedule'],
            y = b['schedule'];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0)); });
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
    PrePlanning: async function(){

      this.$v.$touch();
      if (this.$v.$error)return;

      try {

        this.$store.commit("global/SET_LOADING", true);

        if(this.idSchedule <= 0){
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: "Error",
            show: true,
            type: "error"
          });

        }


        if(this.dates.to < this.dates.from )
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;
        }
        else {
          let ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          const shifthEndTime = toMilitaryTime(ValidateScheduleEdit[0].end_time);
          const shiftStartTime = toMilitaryTime(ValidateScheduleEdit[0].start_time);

          await this.arrayRutas.forEach(async (data) => {
            let PrePlanning = {};
            let IdsError = "";
            PrePlanning.enable = true;
            PrePlanning.period_from = this.dates.from;
            PrePlanning.period_to = this.dates.to;
            PrePlanning.platformsIds = data.platform_id;
            PrePlanning.route_id = data.id
            PrePlanning.shift = this.idSchedule;
            PrePlanning.blockedSeats = this.blockedSeats;
            PrePlanning.availableSeats = this.availableSeats;
            PrePlanning.capacity = this.capacity;
            PrePlanning.errorCodes = []
            const queries = {};
            queries.action = "preset"
            queries.query = {route_id:data.id,
              enabled: true};
            // await promise;
            const resp = await api.Planning(queries);

            const paradas = [];
            resp.data.forEach((data) => {
              let queries = {};
              queries.id = data.id
              queries.route_id = data.route_id
              queries.stop_number = data.stop_number
              queries.stop_name = data.stop_name
              queries.coordenates = data.coordenates
              
              if (data.schedule && data.schedule[this.idSchedule]) {
                queries.schedule = data.schedule[this.idSchedule];

                const scheduleTime = toMilitaryTime(queries.schedule);
                if (shiftStartTime < shifthEndTime) {
                  if (scheduleTime >= shiftStartTime && scheduleTime <= shifthEndTime ) {
                    paradas.push(queries);
                  }
                } else if (shiftStartTime > shifthEndTime) {
                  if (scheduleTime >= shiftStartTime || scheduleTime <= shifthEndTime ) {
                    paradas.push(queries);
                  }
                }
              }
              
            });

            let Stops =  paradas.sort(function (a, b) {
              let x = a['schedule'],
                y = b['schedule'];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });

            const ValidaAnden = this.ArrayPrePlanning.findIndex(function (e) {return e.shift === PrePlanning.shift && e.platformsIds === PrePlanning.platformsIds});
            if(ValidaAnden > 0)
            {
              PrePlanning.error = true;
              PrePlanning.errorCodes.push('duplicated.platform');
              IdsError = IdsError + ", Andén duplicado"
            }
            PrePlanning.IdsError = IdsError;
            PrePlanning.stops_ids = Stops;

            if (paradas.length) {
              this.ArrayPrePlanning.push(PrePlanning);
            }

          },Promise.resolve(setTimeout(() => {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.successful"),
              show: true,
              type: "success"
            });
          },4000)));

          this.massive = true;
          this.checkmassive = false;
          this.ocultar = true;
          this.PlanningGenerate = false;
          this.PlanningGenerateMassive = true;
          this.$v.$reset();
        }
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }

    },
    SavePrePlanning: async function () {
      try{
        this.$store.commit("global/SET_LOADING", true);
        this.PrePlanningCreate = 0;
        this.PrePlanningError = 0;
        this.RutasCreadas  = "";
        await this.ArrayPrePlanning.forEach(async(data,index) =>  {

          let FinalStops = [];
          data.stops_ids.forEach((xdata, index) => {
            let json = {stop_id:xdata.id,
              stop_description:xdata.stop_name,
              stop_coordenates:xdata.coordenates,
              time:xdata.schedule
            };
            FinalStops.push(json)
          });
          let ValidateRuta1 = this.arrayRutas.filter((e) => e.id == data.route_id);

          const queries = {};
          queries.action = "create"
          queries.query= {
            route_id:data.route_id,
            blockedSeats:data.blockedSeats,
            route_description:ValidateRuta1[0].route_name,
            availableSeats:data.availableSeats,
            capacity:data.capacity,
            shift:data.shift,
            platforms_ids:[data.platformsIds],
            period_from:data.period_from,
            period_to:data.period_to,
            stops_ids:FinalStops
          };

          if(data.error)
          {
            this.PrePlanningError = this.PrePlanningError + 1;
          }
          else {
            let ValPlatform = false;
            const queriesValPlatform = {};
            queriesValPlatform.action = "validation_platform"
            queriesValPlatform.query = {
              period_from: data.period_from,
              period_to: data.period_to,
              platform_id: data.platformsIds,
              shift_id: data.shift
            };

            const validatePlatform = await api.ValPlatform(queriesValPlatform);
            if(validatePlatform.data.data.length > 0) {
              const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(data.route_id);
              if(pos < 0 && validatePlatform.data.data.length > 0)
              {
                ValPlatform = true;
                const pos = this.ArrayPrePlanning.map(e => e.route_id).indexOf(data.route_id);
                this.ArrayPrePlanning.splice(pos,1,{
                  error: true,
                  IdsError:"Andén duplicado",
                  route_description:ValidateRuta1[0].route_name,
                  period_from:data.period_from,
                  period_to:data.period_to,
                  blockedSeats:data.blockedSeats,
                  availableSeats:data.availableSeats,
                  capacity:data.capacity,
                  shift:data.shift,
                  route_id:data.route_id,
                  platformsIds:data.platformsIds,
                  stops_ids:FinalStops
                });
              }
              let arr1 = validatePlatform.data.data.map(e => e.route_id);
              let filteredPlatforms= arr1.filter(function(item, pos){
                return arr1.indexOf(item)== pos;
              });
              if(pos >=0 && filteredPlatforms.length > 1)
              {
                ValPlatform = true;
                const pos = this.ArrayPrePlanning.map(e => e.route_id).indexOf(data.route_id);
                this.ArrayPrePlanning.splice(pos,1,{
                  error: true,
                  IdsError:"Andén ocupado por diversas rutas",
                  route_description:ValidateRuta1[0].route_name,
                  period_from:data.period_from,
                  period_to:data.period_to,
                  blockedSeats:data.blockedSeats,
                  availableSeats:data.availableSeats,
                  capacity:data.capacity,
                  shift:data.shift,
                  route_id:data.route_id,
                  platformsIds:data.platformsIds,
                  stops_ids:FinalStops
                });
              }
            }
            if(ValPlatform){
              this.PrePlanningError = this.PrePlanningError + 1;
            }
            else{
              const queriesValidation = {};
              queriesValidation.action = "validation"
              queriesValidation.query= {
                period_from:data.period_from,
                period_to:data.period_to,
                route_id:data.route_id,
                shift:data.shift
              };
              const responseValidate = await api.ValPlanning(queriesValidation);

              if(responseValidate.data.data.length > 0)
              {
                this.idRoute = data.route_id;
                this.availableSeats =data.availableSeats;
                this.capacity=data.capacity;
                this.idSchedule=data.shift;
                this.idPlatform=data.platformsIds;
                this.dates.from=data.period_from;
                this.dates.to=data.period_to;
                this.FinalStops=FinalStops;
                this.validationPlanningMassive = true;

                const queries = {};
                queries.action = "list"
                queries.pagination= {all:false,
                  limit:25,
                  page:1
                };
                queries.filters = {
                  id: responseValidate.data.data[0].planning_id
                }
                const resPlann = await api.Planning(queries);
                let Datos = resPlann.data[0];
                for await( const data of responseValidate.data.data) {
                  let json = {
                    id:Datos.id,
                    reservation:data.control_numbers.length,
                    route_id: Datos.route_id,
                    stops_ids: Datos.stops_ids,
                    platforms_ids: Datos.platforms_ids[0],
                    availableSeats: Datos.availableSeats,
                    blockedSeats: Datos.blockedSeats,
                    shift: Datos.shift,
                    period_from: data.booking_date,
                    period_to: data.booking_date,
                    enabled: true,
                    created_at: Datos.created_at,
                    route_description: ValidateRuta1[0].route_name,
                    capacity: Datos.capacity,
                    usersCancelation: data.control_numbers};
                  this.arrayCancelationMassive.push(json)
                }
                this.$refs['my-cancellation-massive'].show();
                this.$refs['my-information'].show();
                this.$store.commit("global/SET_LOADING", false);
                return;
              }
              const resp = await api.Planning(queries);
              if(resp.message == "Los datos fueron creados correctamente.")
              {
                this.PrePlanningCreate = this.PrePlanningCreate + 1;
                const pos = this.ArrayPrePlanning.map(e => e.route_id).indexOf(data.route_id);
                let ValidateRuta = this.arrayRutas.filter((e) => e.id == data.route_id);
                this.RutasCreadas = this.RutasCreadas + "- " + ValidateRuta[0].route_name;
                this.ArrayPrePlanning.splice(pos, 1);
              }
            }
          }
        },Promise.resolve(setTimeout(() => {
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.successful"),
            show: true,
            type: "success" });

        },2000)));
        this.RutasCreadas = this.RutasCreadas.slice(1);
        this.$refs['my-information'].show();
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.routesCreate")+ this.PrePlanningCreate + "----ERRORES : "+ this.PrePlanningError,
          show: true,
          type: "success"
        });

        this.massive = false;
        this.checkmassive = false;
        this.ocultar = false;
        this.PlanningGenerate = true;
        this.PlanningGenerateMassive = false;
        this.PrePlanningCreate = 0;
        this.PrePlanningError = 0;
        this.RutasCreadas = "";
        this.blockedSeats = 0;
        this.idSchedule = 0;
        this.idPlatform = 0;
        this.dates = {
            from: null,
            to: null
        }
        this.ArrayPrePlanning = [];
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    SavePlanning: async function () {
      this.$v.$touch();
      if(this.$v.$error)return;

      try {

        this.$store.commit("global/SET_LOADING", true);
        if (this.dates.to < this.dates.from) {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("mobilityOnDemand.rango")}`,
            show: true,
            type: "error"
          });
          return;

        }

        if (this.tableData.length == 0) {

          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.addStops")}`,
            show: true,
            type: "error"
          });
          return;
        }
        if (this.idPlatform == 0) {

          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.addPlatform")}`,
            show: true,
            type: "error"
          });
          return;
        }
        this.FinalStops = [];
        let Errores = 0;

        this.tableData.forEach((data) => {
          if (data.error) {
            Errores++;
          }
        });

        const queriesValPlatform = {};
        queriesValPlatform.action = "validation_platform"
        queriesValPlatform.query = {
          period_from: this.dates.from,
          period_to: this.dates.to,
          platform_id: this.idPlatform,
          shift_id: this.idSchedule
        };

        const validatePlatform = await api.ValPlatform(queriesValPlatform);
        const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(this.idRoute);

        if(validatePlatform.data.data.length > 0) {

          if(pos < 0 && validatePlatform.data.data.length > 0)
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.platformBusy")}`,
              show: true,
              type: "error" });
            return;
          }
          let arr1 = validatePlatform.data.data.map(e => e.route_id);
          let filteredPlatforms= arr1.filter(function(item, pos){
            return arr1.indexOf(item)== pos;
          });
          if(pos >=0 && filteredPlatforms.length > 1)
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              //msg: `${this.$t("bookingTransport.platformBusy")}`,
              msg: "Andén ocupado por diversas rutas",
              show: true,
              type: "error" });
            return;
          }
        }
        if(Errores>0)
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.addedStops")}`  + Errores,
            show: true,
            type: "error" });
          return;
        }
        else if(Errores==0)
        {
          this.tableData.forEach((data, index) => {
            let json = {stop_id:data.id,
              stop_description:data.stop_name,
              stop_coordenates:data.coordenates,
              time:data.schedule};
            this.FinalStops.push(json)
          });
          const queriesValidation = {};
          queriesValidation.action = "validation"
          queriesValidation.query= {
            period_from:this.dates.from,
            period_to:this.dates.to,
            route_id:this.idRoute,
            shift:this.idSchedule
          };
          const responseValidate = await api.ValPlanning(queriesValidation);
          if(responseValidate.data.data.length > 0)
          {
            this.validationPlanning = true;
            const queries = {};
            queries.action = "list"
            queries.pagination= {all:false,
              limit:25,
              page:1
            };
            queries.filters = {
              id: responseValidate.data.data[0].planning_id
            }
            const resPlann = await api.Planning(queries);
            let Datos = resPlann.data[0];

            for await( const data of responseValidate.data.data) {
              let json = {
                id:Datos.id,
                reservation:data.control_numbers.length,
                route_id: Datos.route_id,
                stops_ids: Datos.stops_ids,
                platforms_ids: Datos.platforms_ids[0],
                availableSeats: Datos.availableSeats,
                blockedSeats: Datos.blockedSeats,
                shift: Datos.shift,
                period_from: data.booking_date,
                period_to: data.booking_date,
                enabled: true,
                created_at: Datos.created_at,
                route_description: Datos.route_description,
                capacity: Datos.capacity,
                usersCancelation: data.control_numbers};
              this.arrayCancelationMassive.push(json)
            }
            this.$refs['my-cancellation-massive'].show();
            this.$store.commit("global/SET_LOADING", false);
            return;
          }
          let NameRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          NameRuta[0].route_name;
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_id:this.idRoute,
            route_description: NameRuta[0].route_name,
            blockedSeats:this.blockedSeats,//Libres
            availableSeats:this.availableSeats,//Asientos bloqueados
            capacity:this.capacity,//Capacidad
            shift:this.idSchedule,
            platforms_ids:[this.idPlatform],
            period_from:this.dates.from,
            period_to:this.dates.to,
            stops_ids:this.FinalStops
          };
          const resp = await api.Planning(queries);
          this.EditPrePlanning = false;
          this.idRoute = 0;
          this.capacity = 44;
          this.idSchedule = 0;
          this.idPlatform = 0;
          this.dates.from = "";
          this.dates.to = "";
          this.tableData = [];
          this.UpdateplanningTable();
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.planning.planingCreate"),
            show: true,
            type: "success"
          });
          this.$v.$reset();
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    closeMyCancellationMassive()
    {
      this.EditPrePlanning = false;
      this.idRoute = 0;
      this.availableSeats = 40;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];
      this.arrayCancelationMassive = [];
      this.$refs['my-cancellation-massive'].hide();
    },

    EditMyCancellation()
    {
      this.$refs['my-cancellation'].hide();

    },
    EditAddConfirm(){
      try{
        this.$store.commit("global/SET_LOADING", true);

        this.carrito.forEach((data)=>{
          let queries = {};
          queries.id = data.id
          queries.route_id = data.route_id
          queries.stop_number = data.stop_number
          queries.stop_name = data.stop_name
          queries.coordenates = data.coordenates

          if (data.schedule == null)
          {
            queries.schedule = "Ninguno"
          }
          else if (data.schedule != null)
          {
            queries.schedule = data.schedule
            if(queries.schedule == undefined){
              queries.schedule = "Ninguno"
            }else{
              queries.schedule = data.schedule
            }
          }

          if(queries.schedule.length>=4 && queries.schedule.length<5){
            queries.schedule = "0"+ queries.schedule;
          }

          if(queries.schedule !="Ninguno" && queries.schedule != null){
            if(queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)
            {
              queries.error = false;

            }
            else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){

              if((queries.schedule+":00"  >= this.ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)){
                queries.error = false;
              }
              else{
                queries.error = true;
              }
            }
            else{
              queries.error = true;
            }
          }
          else if(queries.schedule != null) {
            queries.error = true;
          }
          this.tableData.push(queries)

        });
        let organize =  this.tableData;
        this.tableData =  organize.sort(function (a, b) {
          let x = a['schedule'],
            y = b['schedule'];
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t("bookingTransport.planning.addedStops") + this.carrito.length ,
          show: true,
          type: "success"
        });
        this.carrito=[];
        this.carritoAdd=[];
        this.$refs['add-Stops'].hide();
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },
    EditConfirmMassiveCancelation: async function(){
      try{
        this.$store.commit("global/SET_LOADING", true);
        if(this.validationPlanning == true)
        {
          let idruta = this.idRoute;
          let NameRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_id:this.idRoute,
            route_description: NameRuta[0].route_name,
            blockedSeats:this.blockedSeats,//Libres
            availableSeats:this.availableSeats,//Asientos bloqueados
            capacity:this.capacity,//Capacidad
            shift:this.idSchedule,
            platforms_ids:[this.idPlatform],
            period_from:this.dates.from,
            period_to:this.dates.to,
            stops_ids:this.FinalStops
          };
          const resp = await api.Planning(queries);
          this.EditPrePlanning = false;
          this.idRoute = 0;
          this.availableSeats = 40;
          this.capacity = 44;
          this.idSchedule = 0;
          this.idPlatform = 0;
          this.dates.from = "";
          this.dates.to = "";
          this.tableData = [];
          this.UpdateplanningTable();

          for await(const data of this.arrayCancelationMassive) {

            if(data.usersCancelation.length>0)
            {
              let ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
              let period_from = moment(data.period_from).utc().format('YYYY-MM-DD')
              const queries = {
                type: "BookingCancellation",
                priority: "booking",
                controlNumbers: data.usersCancelation,
                title: "Reservación cancelada",
                subtitle: "Modificación de ruta " + ValidateRuta[0].route_name,
                cover: null,
                body: {
                  ops: [
                    {
                      insert: "Modificación de ruta " + ValidateRuta[0].route_name +"\nTe informamos que la ruta " + ValidateRuta[0].route_name + " del día " + period_from +  "  ha sido modificada por Servicios de Movilidad, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                    }
                  ]
                },
                author: "Audi México"
              };
              const notifix = await api.postNotif(queries);
            }
          }
          let NameRuta1 = this.arrayRutas.filter((e)=> e.id == idruta);
          this.validationPlanning = false;
          this.arrayCancelationMassive = [];
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.planning.planingCreate") + NameRuta1[0].route_name,
            show: true,
            type: "success"
          });

        }
        if(this.validationPlanningMassive == true)
        {
          let idruta = this.idRoute;
          let NameRuta2 = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          const queries = {};
          queries.action = "create"
          queries.query= {
            route_id:this.idRoute,
            route_description:NameRuta[0].route_name,
            blockedSeats:this.blockedSeats,//Libres
            availableSeats:this.availableSeats,//Asientos bloqueados
            capacity:this.capacity,//Capacidad
            shift:this.idSchedule,
            platforms_ids:[this.idPlatform],
            period_from:this.dates.from,
            period_to:this.dates.to,
            stops_ids:this.FinalStops
          };
          const resp = await api.Planning(queries);
          this.EditPrePlanning = false;
          this.idRoute = 0;
          this.availableSeats = 40;
          this.capacity = 44;
          this.idSchedule = 0;
          this.idPlatform = 0;
          this.dates.from = "";
          this.dates.to = "";
          this.tableData = [];
          this.UpdateplanningTable();

          for await(const data of this.arrayCancelationMassive) {

            if(data.usersCancelation.length>0)
            {
              let ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
              let period_from = moment(data.period_from).utc().format('YYYY-MM-DD')

              const queries = {
                type: "BookingCancellation",
                priority: "booking",
                controlNumbers: data.usersCancelation,
                title: "Reservación cancelada",
                subtitle: "Modificación de ruta " + NameRuta2[0].route_name,
                cover: null,
                body: {
                  ops: [
                    {
                      insert: "Modificación de ruta " + NameRuta2[0].route_name +"\n Te informamos que la ruta " + NameRuta2[0].route_name + " del día " + period_from + " ha sido modificada por Servicios de Movilidad, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                    }
                  ]
                },
                author: "Audi México"
              };
              const notifix = await api.postNotif(queries);
            }
          }
          let NameRuta = this.arrayRutas.filter((e)=> e.id == idruta);
          this.validationPlanning = false;
          this.arrayCancelationMassive = [];
          this.$store.commit("global/SET_LOADING", false);
          this.$refs['my-cancellation-massive'].hide();
          this.$store.commit("global/SET_ALERT", {
            msg: this.$t("bookingTransport.planning.planingCreate") + NameRuta[0].route_name,
            show: true,
            type: "success"
          });
          const pos = this.ArrayPrePlanning.map(e => e.route_id).indexOf(idruta);
          this.ArrayPrePlanning.splice(pos, 1);

        }
        else{

          for await( const data of this.arrayCancelationMassive ) {

            const queries = {};
            queries.action = "update"
            queries.query= {
              id:data.id,
              enabled: false,
              route_id: data.route_id,
              blockedSeats: data.blockedSeats,
              availableSeats: data.availableSeats,
              capacity: data.capacity,
              shift: data.shift,
              platforms_ids: data.platforms_ids,
              period_from: data.period_from,
              period_to: data.period_to,
              stops_ids: data.stops_ids
            };

            const respx = await api.Planning(queries);

            if(respx.message =="Los datos fueron actualizados correctamente.")

            {

              if(data.usersCancelation.length>0)

              {
                let ValidateRuta = this.arrayRutas.filter((e)=> e.id == data.route_id);
                let period_from = moment(data.period_from).utc().format('YYYY-MM-DD')

                const queries = {
                  type: "BookingCancellation",
                  priority: "booking",
                  controlNumbers: data.usersCancelation,
                  title: "Reservación cancelada",
                  subtitle: "Suspensión temporal de servicios de transporte",//ValidateRuta[0].route_name,
                  cover: null,
                  body: {
                    ops: [
                      {
                        insert: "Suspensión temporal de servicios de transporte \nLamentamos informarte que tu reserva para " + ValidateRuta[0].route_name + " del día " + period_from + " ha sido cancelada por Servicios de Movilidad debido a una suspensión temporal en los servicios de transporte ofrecidos para ese día. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                      }
                    ]
                  },
                  author: "Audi México"
                };
                const notifix = await api.postNotif(queries);
              }
            }
          }
        }
        this.UpdateplanningTable();
        this.$refs['my-cancellation-massive'].hide();
        this.$store.commit("global/SET_LOADING", false);
      }

      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },


    EditConfirmPrePlanning: async function(){
      try{

        this.$v.$touch();
        if(this.$v.$error)return;

        this.$store.commit("global/SET_LOADING", true);
        let route = this.idRoute;
        let idSchedule = this.idSchedule
        const pos = this.ArrayPrePlanning.findIndex(function (e) { return e.route_id === route && e.shift === idSchedule });

        if(this.DeleteRowPreplanning){
          this.ArrayPrePlanning.splice(pos,1);
          this.$store.commit("global/SET_LOADING", false);
          this.$refs['Pre-Planning-edit'].hide();
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
            show: true,
            type: "success"
          });
        }
        else{

          if(this.dates.to < this.dates.from )
          {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("mobilityOnDemand.rango")}`,
              show: true,
              type: "error"
            });
            return;

          }
          if(this.tableData.length == 0)  {

            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.planning.addStops"),
              show: true,
              type: "error" });
            return;

          }
          if(this.idPlatform == 0)  {
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg: this.$t("bookingTransport.planning.addPlatform"),
              show: true,
              type: "error" });
            return;
          }

          const queriesValPlatform = {};
          queriesValPlatform.action = "validation_platform"
          queriesValPlatform.query = {
            period_from: this.dates.from,
            period_to: this.dates.to,
            platform_id: this.idPlatform,
            shift_id: this.idSchedule
          };

          const validatePlatform = await api.ValPlatform(queriesValPlatform);

          if(validatePlatform.data.data.length > 0) {

            const pos = validatePlatform.data.data.map(e => e.route_id).indexOf(this.idRoute);

            if(pos < 0 && validatePlatform.data.data.length > 0)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.platformBusy")}`,
                show: true,
                type: "error" });

              return;
            }

            let arr1 = validatePlatform.data.data.map(e => e.route_id);
            let filteredPlatforms= arr1.filter(function(item, pos){
              return arr1.indexOf(item)== pos;
            });
            if(pos >=0 && filteredPlatforms.length > 1)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: "Andén ocupado por diversas rutas",
                show: true,
                type: "error" });

              return;
            }
          }
          if(this.EditPrePlanning)
          {
            let ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
            const paradas = [];
            this.tableData.forEach((data) => {
              let queries = {};
              queries.id = data.id
              queries.route_id = data.route_id
              queries.stop_number = data.stop_number
              queries.stop_name = data.stop_name
              queries.coordenates = data.coordenates
              if (data.schedule == null)
              {
                queries.schedule = "Ninguno"
              }
              else if (data.schedule != null)
              {
                queries.schedule = data.schedule
                if(queries.schedule == undefined){
                  queries.schedule = "Ninguno"
                }
                else{
                  queries.schedule = data.schedule
                }
              }
              if(queries.schedule.length>=4 && queries.schedule.length<5){
                queries.schedule = "0"+ queries.schedule;
              }
              if(queries.schedule !="Ninguno" && queries.schedule != null){

                if(queries.schedule+":00" >= ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= ValidateScheduleEdit[0].end_time)
                {
                  queries.error = false;
                }
                else if(ValidateScheduleEdit[0].end_time <= ValidateScheduleEdit[0].start_time){
                  if((queries.schedule+":00"   >= ValidateScheduleEdit[0].start_time)||(queries.schedule+":00"  >= '00:00' && queries.schedule+":00"  <= ValidateScheduleEdit[0].end_time)){

                    queries.error = false;
                  }
                  else{
                    queries.error = true;

                  }
                }
                else{
                  queries.error = true;

                }
              }
              else if(queries.schedule != null) {
                queries.error = true;
              }
              paradas.push(queries);
            });
            this.tableData = paradas;
            this.FinalStops = [];
            let Errores = 0;
            this.tableData.forEach((data) => {if(data.error) {Errores++;} });
            if(Errores>0)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: this.$t("bookingTransport.planning.stopError") + Errores,
                show: true,
                type: "error" });
              return;
            }
            else if(Errores==0)
            {
              let organize =  this.tableData;
              this.tableData =  organize.sort(function (a, b) {
                let x = a['schedule'],
                  y = b['schedule'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
              });
              this.tableData.forEach((data, index) => {
                let json = {stop_id:data.id,
                  stop_description:data.stop_name,
                  stop_coordenates:data.coordenates,
                  time:data.schedule};
                this.FinalStops.push(json)
              });
              let NameRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
              const queries = {};
              queries.action = "update"
              queries.query= {
                id:this.IdPlanning,
                enabled:this.EnablePlanning,
                route_id:this.idRoute,
                route_description: NameRuta[0].route_name,
                blockedSeats:this.blockedSeats,
                availableSeats:this.availableSeats,
                capacity:this.capacity,
                shift:this.idSchedule,
                platforms_ids:[this.idPlatform],
                period_from:this.dates.from,
                period_to:this.dates.to,
                stops_ids:this.FinalStops
              };
              const resp = await api.Planning(queries);

              if(resp.message =="Los datos fueron actualizados correctamente.")

              {
                if(this.arrayCancellation.length>0)
                {
                  let ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
                  let period_from = moment(this.dates.from).utc().format('YYYY-MM-DD')
                  let period_to = moment(this.dates.to).utc().format('YYYY-MM-DD')

                  const queries = {
                    type: "BookingCancellation",
                    priority: "booking",
                    controlNumbers: this.arrayCancellation,
                    title: "Reservación cancelada",
                    subtitle: "Modificación de ruta " + ValidateRuta[0].route_name,
                    cover: null,
                    body: {
                      ops: [
                        {
                          insert: "Modificación de ruta " + ValidateRuta[0].route_name + "\nLamentamos informarte que la planeación de la ruta "+ ValidateRuta[0].route_name + " del periodo " + period_from + " al " + period_to+ " ha sido modificada por Servicios de Movilidad debido a ajustes en la planeación de servicios para este periodo, por tal motivo tu reserva ha sido cancelada. Por favor revisa en el apartado de transporte las nuevas rutas programadas."
                        }
                      ]
                    },
                    author: "Audi México"
                  };
                  const notifix = await api.postNotif(queries);
                }
                this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
                  show: true,
                  type: "success"
                });
                this.EditPrePlanning = false;
                this.IdPlanning = 0;
                this.idRoute = 0;
                this.route_description = "";
                this.blockedSeats = 0;
                this.capacity = 44;
                this.idSchedule = 0;
                this.idPlatform = 0;
                this.dates.from = "";
                this.dates.to = "";
                this.tableData = [];
                this.UpdateplanningTable();
                this.$refs['Pre-Planning-edit'].hide();
                this.$store.commit("global/SET_LOADING", false);
                this.$v.$reset();
              }
              else
              {
                this.$store.commit("global/SET_LOADING", false);
                this.$store.commit("global/SET_ALERT", {
                  msg: resp.message,
                  show: true,
                  type: "error"
                });
              }
            }
          }
          else{
            let Stops = [];
            let errorStop = false;
            let IdsError = "";
            let ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
            this.tableData.forEach((data, index) => {
              let queries = {};
              queries.id = data.id
              queries.route_id = data.route_id
              queries.stop_number = data.stop_number
              queries.stop_name = data.stop_name
              queries.coordenates = data.coordenates
              if (data.schedule == null)
              {
                queries.schedule = "Ninguno"
              }
              else if (data.schedule != null)
              {
                queries.schedule = data.schedule
                if(queries.schedule == undefined){
                  queries.schedule = "Ninguno"
                }
                else{
                  queries.schedule = data.schedule
                }
              }
              if(queries.schedule.length>=4 && queries.schedule.length<5){
                queries.schedule = "0"+ queries.schedule;
              }
              if(queries.schedule !="Ninguno" && queries.schedule != null){
                if(queries.schedule+":00" >= ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= ValidateScheduleEdit[0].end_time)
                {
                  queries.error = false;
                }
                else if(ValidateScheduleEdit[0].end_time <= ValidateScheduleEdit[0].start_time){

                  if((queries.schedule+":00"  >= ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00" <= ValidateScheduleEdit[0].end_time)){
                    queries.error = false;
                  }
                  else{
                    errorStop = true;
                    queries.error = true;
                    IdsError = IdsError + "," + queries.id;
                  }
                }
                else{
                  errorStop = true;
                  queries.error = true;
                  IdsError = IdsError + "," + queries.id;
                }
              }

              else if(queries.schedule != null) {
                errorStop = true;
                queries.error = true;
                IdsError = IdsError + "," + queries.id;
              }
              Stops.push(queries);
            });
            this.tableData =  Stops.sort(function (a, b) {
              let x = a['schedule'],
                y = b['schedule'];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));});
            if(this.tableData.length == 0)
            {
              errorStop = true;
              IdsError = "Error: Horarios"
            }
            let Shift = this.idSchedule;
            let Platform = this.idPlatform;

            const ValidaAnden = this.ArrayPrePlanning.findIndex(function (e) {return e.shift === Shift && e.platformsIds === Platform});
            if(ValidaAnden > 0)
            {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: this.$t("Andén duplicado"),
                show: true,
                type: "error" });
              return;
            }
            this.ArrayPrePlanning.splice(pos,1,{
              error: errorStop,
              IdsError:IdsError,
              period_from:this.dates.from,
              period_to:this.dates.to,
              blockedSeats:this.blockedSeats,
              availableSeats:this.availableSeats,
              capacity:this.capacity,
              shift:this.idSchedule,
              route_id:this.idRoute,
              platformsIds:this.idPlatform,
              stops_ids:this.tableData
            });
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
              show: true,
              type: "success"
            });

            this.EditPrePlanning = false;
            this.IdPlanning = 0;
            this.idRoute = 0;
            this.route_description = "";
            this.blockedSeats = 0;
            this.capacity = 44;
            this.idSchedule = 0;
            this.idPlatform = 0;
            this.dates.from = "";
            this.dates.to = "";
            this.tableData = [];
            this.$refs['Pre-Planning-edit'].hide();
            this.$store.commit("global/SET_LOADING", false);
            this.$v.$reset();
          }
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    EditConfirm(){

      try{
        this.$store.commit("global/SET_LOADING", true);
        const pos = this.tableData.map(e => e.id).indexOf(this.id_parada);
        if(this.DeleteStop){
          this.tableData.splice(pos,1);
          this.$store.commit("global/SET_ALERT", {
            msg: `${this.$t("bookingTransport.planning.deleteSuccess")}`,
            show: true,
            type: "success"
          });
        }
        else{

          let ValidateSchedule = [];
          ValidateSchedule = this.arraySchedule.filter((e)=> e.id == this.idSchedule);

          if(this.schedule+":00" >= ValidateSchedule[0].start_time && this.schedule+":00" <= ValidateSchedule[0].end_time){

            this.$store.commit("global/SET_LOADING", false);
            this.tableData.splice(pos,1,{
              numero:this.numero,
              id:this.id_parada,
              route_id:this.route_id,
              stop_number:this.stop_number,
              stop_name:this.stop_name,
              coordenates:this.coordenates,
              schedule:this.schedule
            });
            this.$store.commit("global/SET_ALERT", {
              msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
              show: true,
              type: "success"
            });


            this.tableData =  this.tableData.sort(function (a, b) {
              let x = a['schedule'],
                y = b['schedule'];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });

            this.$refs['my-edit'].hide();
          }
          else if(ValidateSchedule[0].end_time <= ValidateSchedule[0].start_time){


            if((this.schedule+":00" >= ValidateSchedule[0].start_time)||(this.schedule+":00">= '00:00' && this.schedule+":00" <= ValidateSchedule[0].end_time)){

              this.$store.commit("global/SET_LOADING", false);
              this.tableData.splice(pos,1,{
                numero:this.numero,
                id:this.id_parada,
                route_id:this.route_id,
                stop_number:this.stop_number,
                stop_name:this.stop_name,
                coordenates:this.coordenates,
                schedule:this.schedule
              });
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("bookingTransport.planning.updatedSuccess")}`,
                show: true,
                type: "success"
              });


              this.tableData =  this.tableData.sort(function (a, b) {
                let x = a['schedule'],
                  y = b['schedule'];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
              });
              this.$refs['my-edit'].hide();
              return;


            }
            else{
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg:  `${this.$t("bookingTransport.Nocorresponds")}`,
                show: true,
                type: "error"
              });
            }
          }
          else{
            this.$store.commit("global/SET_LOADING", false);
            this.$store.commit("global/SET_ALERT", {
              msg:  `${this.$t("bookingTransport.Nocorresponds")}`,
              show: true,
              type: "error"
            });

          }
          return;
        }

        this.$store.commit("global/SET_LOADING", false);
        this.$refs['my-edit'].hide();

      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    closeEdit(){
      this.$refs['my-edit'].hide();
    },
    closeEditPrePlanning(){

      this.EditPrePlanning = false;
      this.idRoute = 0;
      this.blockedSeats = 0;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];
      this.$v.$reset();
      this.$refs['Pre-Planning-edit'].hide();
    },

    CloseInformation(){
      this.UpdateplanningTable();
      this.$refs['my-information'].hide();
    },

    closeMyCancellation(){

      this.EditPrePlanning = false;
      this.idRoute = 0;
      this.availableSeats = 40;
      this.capacity = 44;
      this.idSchedule = 0;
      this.idPlatform = 0;
      this.dates.from = "";
      this.dates.to = "";
      this.tableData = [];

      this.$refs['Pre-Planning-edit'].hide();
      this.$refs['my-cancellation'].hide();

    },

    closeAddRoute(){
      this.carrito=[];
      this.carritoAdd=[];
      this.$refs['add-Stops'].hide();
    },
    async chk(data,cb)
    {
      try{
        if(cb.target.checked == true && data.enabled == false)
        {
          this.carrito.push(data);
        }
        else{
          this.carrito = this.carrito.filter((e)=> e !== data)
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });

      }
    },

    Schedule (status) {

      if (status == null)
      {
        return "Ninguno"
      }
      else if (status != null)
      {
        for (let i in status) {
        }
        return status[this.idSchedule]
      }


    },

    showSetStops: async function (index) {

      try {
        if((this.idRoute != null && this.idSchedule != null)&&(this.idRoute != 0 && this.idSchedule != 0)){
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          let ValidateRuta = this.arrayRutas.filter((e)=> e.id == this.idRoute);
          this.idPlatform =  ValidateRuta[0].platform_id;

          this.tableData = [];
          let Stops = [];
          this.$store.commit("global/SET_LOADING", true);
          const queries = {};
          queries.action = "preset"
          queries.query = {
            route_id:this.idRoute,
            enabled: true
          };
          const resp = await api.Planning(queries);
          let numero = 0;
          resp.data.forEach((data, index) => {
            let queries = {};
            queries.numero = numero++
            queries.id = data.id
            queries.route_id = data.route_id
            queries.stop_number = data.stop_number
            queries.stop_name = data.stop_name
            queries.coordenates = data.coordenates
            if (data.schedule == null)
            {
              queries.schedule = "Ninguno"
            }
            else if (data.schedule != null)
            {
              queries.schedule = data.schedule[this.idSchedule]
              if(queries.schedule == undefined){
                queries.schedule = "Ninguno"
              }else{
                queries.schedule = data.schedule[this.idSchedule]
              }
            }

            if(queries.schedule.length>=4 && queries.schedule.length<5){
              queries.schedule = "0"+ queries.schedule;
            }
            if(queries.schedule !="Ninguno" && queries.schedule != null){

              if(queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time && queries.schedule+":00" <= this.ValidateScheduleEdit[0].end_time)
              {
                queries.error = false;
              }
              else if(this.ValidateScheduleEdit[0].end_time <= this.ValidateScheduleEdit[0].start_time){
                if((queries.schedule+":00" >= this.ValidateScheduleEdit[0].start_time)||(queries.schedule+":00" >= '00:00' && queries.schedule+":00"  <= this.ValidateScheduleEdit[0].end_time)){
                  queries.error = false;
                }
                else{
                  queries.error = true;
                }
              }
              else{
                queries.error = true;
              }
            }
            else if(queries.schedule != null) {
              queries.error = true;
            }
            Stops.push(queries);
          });
          this.tableData =  Stops.sort(function (a, b) {
            let x = a['schedule'],
              y = b['schedule'];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));});
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
          this.$store.commit("global/SET_LOADING", false);
        }
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    getRoutes: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.catalogType = "routes"
        queries.pagination= {
          all: false,
          limit: 300,
          page: 1
        };
        queries.filters = { route_name: this.filterRoutes };
        const resp = await api.getLists(queries);
        this.arrayRutas = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    getSchedule: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.action = "list"
        queries.pagination= {all:false,
          limit:300,
          page:1};
        queries.filters = {
          shift_name:this.filterSchedule};
        const resp = await api.getSchedule(queries);
        this.arraySchedule = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(eror){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: eror,
          show: true,
          type: "error"
        });
      }
    },

    getPlatform: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {};
        queries.catalogType = "platforms"
        queries.pagination= {
          all:true,
          limit:2,
          page:1};
        queries.filters = {
          platform_name:this.filterPlatform};
        const resp = await api.getLists(queries);
        this.arrayPlatform = resp.data;
        this.$store.commit("global/SET_LOADING", false);
      }
      catch(eror){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: eror,
          show: true,
          type: "error"
        });
      }
    },

    ModifyPrePlanning: async function(data,action,origin){      
      this.$store.commit("global/SET_LOADING", true);
      try{
        if(origin=="planning")
        {
          const queries = {};
          queries.planningId =  data.id; //73;
          const resp = await api.Cancellation(queries);
          this.arrayCancellation =  resp.data;
          this.$refs['Pre-Planning-edit'].show();
          if(this.arrayCancellation.length)
          {
            this.$refs['my-cancellation'].show();
          }
          this.EditPrePlanning = true;
          this.EnablePlanning = data.enabled;
          this.DeleteRowPreplanning = action;
          this.tableData = [];
          this.IdPlanning = data.id;
          this.dates.from = data.period_from;
          this.dates.to = data.period_to;
          this.blockedSeats = data.blockedSeats;
          this.capacity = data.capacity;
          this.idSchedule = data.shift;
          this.idRoute = data.route_id;
          this.idPlatform = data.platformsIds;
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
          data.stops_ids.forEach((data, index) => {
            let queries = {};
            queries.id = data.stop_id
            queries.stop_name = data.stop_description
            queries.coordenates = data.stop_coordenates
            queries.schedule = data.time
            queries.error = data.error
            this.tableData.push(queries);
          });
          this.$store.commit("global/SET_LOADING", false);
        }
        else
        {
          this.DeleteRowPreplanning = action;
          this.tableData = [];
          // = data.enable, stops_ids
          this.dates.from = data.period_from;
          this.dates.to = data.period_to;
          this.blockedSeats = data.blockedSeats;
          //this.availableSeats = data.availableSeats;
          this.capacity = data.capacity;
          this.idSchedule = data.shift;
          this.idRoute = data.route_id;
          this.idPlatform = data.platformsIds;
          this.ValidateScheduleEdit  = this.arraySchedule.filter((e)=> e.id == this.idSchedule);
          this.ScheduleValidate.shift_name = this.ValidateScheduleEdit[0].shift_name;
          this.ScheduleValidate.start_time = this.ValidateScheduleEdit[0].start_time;
          this.ScheduleValidate.end_time = this.ValidateScheduleEdit[0].end_time;
          data.stops_ids.forEach((data, index) => {
            let queries = {};
            queries.id = data.id
            queries.route_id = data.route_id
            queries.stop_number = data.stop_number
            queries.stop_name = data.stop_name
            queries.coordenates = data.coordenates
            queries.schedule = data.schedule
            queries.error = data.error
            this.tableData.push(queries);
          });
          this.$store.commit("global/SET_LOADING", false);
          this.$refs['Pre-Planning-edit'].show();
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },

    ModifyStops: function(data,action){
      this.DeleteStop = action;
      this.numero=data.numero;
      this.id_parada=data.id;
      this.route_id=data.route_id;
      this.stop_number=data.stop_number;
      this.stop_name=data.stop_name;
      this.coordenates=data.coordenates;
      this.schedule=data.schedule;
      this.$refs['my-edit'].show();

    },

    DeleteStops: function(data){
      this.DeleteStop = true;
      this.$refs['my-edit'].show();
      return;
      const pos = this.tableData.map(e => e.numero).indexOf(data.numero);
      this.tableData.splice(pos,1);
    },


    Modify: function(stops_ids,enabled,shift_name,start_date,end_date,start_time,end_time){

      console.log(stops_ids);

      // for (i = 0; i < stops_ids.length; i++) {
      //     console.log(numeros[i]);
      //     }

      stops_ids.forEach((data, index) => {
        console.log('Indice: ' + index + ' Valor: ' + data.stop_id);
      });


      // this.edit = true;
      // this.id = id;
      // this.picked = enabled;
      // this.EditSchedule = shift_name;
      // this.dates.from = start_date;
      // this.dates.to = end_date;
      // this.timeFromApp = start_time;
      // this.timeToApp = end_time;
      this.$refs['my-edit'].show();

    },

    reloadComponent: function () {
      /* this is a hot fix, the better way is reseting all variables */
        this.$emit('reloadComponent')
    }
  },

  filters: {

    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }
      return moment(value).utc().format('YYYY-MM-DD')
    },

  },

  computed:{
    appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },
    availableSeats:function(){
      return   this.capacity - this.blockedSeats;
    },
    planningTable: function(){
      return this.$refs.planningTable;
    },
    PrePlanningTable: function() {
      return this.$refs.PrePlanningTable;
    },
    tableAddStops_columns: function() {
      return [    "Stopschk",
        "id",
        // "route_id",
        // "stop_number",
        "stop_name",
        "coordenates",
        "schedule",
        // "edit",
        // "remove"
      ];
    },

    table_headingsAddStops: function () {
      if (this.tableAddStops_columns) {
        const headings = {};
        this.tableAddStops_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableStops.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersAddStops: function () {
      return this.tableAddStops_columns.filter((column) => column !== "edit" && column !== "remove");
    },
    table_optionsAddStops: function () {
      return {
        columns: this.tableAddStops_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsAddStops,
            filterable: this.table_filtersAddStops,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 50,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },





    tableAddCancelation_columns: function() {
      return [
        // "enable",
        "reservation",
        "id",
        "created_at",
        "enabled",
        "period_from",
        "period_to",
        "platforms_ids",
        "route_id",
        "shift",
        "availableSeats",
        "blockedSeats",
        "capacity",
        // "stops_ids",

      ];
    },

    table_headingsAddCancelation: function () {
      if (this.tableAddCancelation_columns) {
        const headings = {};
        this.tableAddCancelation_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableCancelation.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersAddCancelation: function () {
      return this.tableAddCancelation_columns.filter((column) => column !== "edit" );
    },
    table_optionsAddCancelation: function () {
      return {
        columns: this.tableAddCancelation_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsAddCancelation,
            filterable: this.table_filtersAddCancelation,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 50,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableCancelation.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableCancelation.headings.limit")
            },
          },
      };
    },

    planningTable: function() {
      return this.$refs.planningTable;
    },


    table_preplanning_columns: function(){
      return [
        // "enable",
        "period_from",
        "period_to",
        "platformsIds",
        "route_id",
        "shift",
        "blockedSeats",
        "availableSeats",
        "capacity",
        //"stops_ids",
        "error",
        "actions",
        "eliminar"
      ]
    },

    table_preplanning_headings: function() {
      if (this.table_preplanning_columns) {
        const headings = {};
        this.table_preplanning_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.planning.TablePlanning.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },

    table_filters_preplanning: function () {
      return this.table_preplanning_columns.filter((column) => column !== "actions" && column !== "eliminar"  && column !== "enable"  && column !== "period_from" && column !== "period_to"); //&& column !== "error"
    },

    table_options_preplanning: function () {

      return {
        columns: this.table_preplanning_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_preplanning_headings,
            filterable: this.table_filters_preplanning,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 15,
            perPageValues: [10, 25, 50, 100],
            columnsClasses: {
              created_at: "created_at",
              //period_from: "actions-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },



    table_columns: function() {
      return [
        "id",
        "created_at",
        "carritochk",
        "enabled",
        "period_from",
        "period_to",
        "platformsIds",
        "route_id",
        "shift",
        "blockedSeats",
        "availableSeats",
        "capacity",
        // "stops_ids",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `bookingTransport.planning.TablePlanning.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions" && column !== "carritochk"&& column !== "enabled");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          columnsClasses: {
            created_at: "select-columncreated_at",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("bookingTransport.planning.TablePlanning.headings.column_toggler"),
            limit: this.$t("bookingTransport.planning.TablePlanning.headings.limit")

          },

          requestAdapter: function(data) {
            const queries = {};
            queries.action = "list"
            queries.pagination= {all:false,
              limit:data.limit,
              page:data.page
            };
            let jsonRequest = {route_type: "default"};
            let xquery = Object.assign(jsonRequest, data.query)
            queries.filters =  xquery;
            return queries;

          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {

              const resp = await api.Planning(data);
              this.$store.commit("global/SET_LOADING", false);
              // console.log(resp);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit("global/SET_ALERT", {
                msg: `${error}`,
                show: true,
                type: "error"
              });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    },

    tableStops_columns: function() {
      return [    "id",
        // "route_id",
        // "stop_number",
        "stop_name",
        "coordenates",
        "schedule",
        "error",
        "edit",
        "remove"];
    },

    table_headingsStops: function () {
      if (this.tableStops_columns) {
        const headings = {};
        this.tableStops_columns.forEach((column) => {
          headings[column] = this.$t(`bookingTransport.planning.TableStops.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersStops: function () {
      return this.tableStops_columns.filter((column) => column !== "edit" && column !== "remove");
    },
    table_optionsCarga: function () {

      return {
        columns: this.tableStops_columns,
        options:
          {
            columnsDropdown: true,
            filterByColumn: true,
            headings: this.table_headingsStops,
            filterable: this.table_filtersStops,
            sortable: [],
            resizableColumns: false,// columnas fijas
            perPage: 5,
            perPageValues: [5,10, 25, 50, 100],
            columnsClasses: {
              select: "select-column",
              id: "id-column",
            },
            texts: {
              filterBy: "{column}",
              columns: this.$t("bookingTransport.planning.TableStops.headings.column_toggler"),
              limit: this.$t("bookingTransport.planning.TableStops.headings.limit")
            },
          },
      };
    },
  }
}

</script>

<style lang="scss">

/*.VueTables__route_id-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#route_id{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__shift-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#shift{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}*/

#AddCancelationMassive .table-responsive {
  height:400px;
  width: auto;
  overflow:scroll;
}
.VueTables__created_at-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#created_at{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__period_from-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#period_from{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.VueTables__period_to-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
}
#period_to{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
}
#Planning-booking {
  background-color: $white;
  padding: 2rem 4rem;
}
#PrePlanningTable .table-responsive {
  height:auto;
  width: auto;
  overflow:scroll;
}
.actions-column {
  position: relative;
  z-index: 1;
  left: 0;
  text-align: center;
  width: 5%;
}
#PlanningStops .table-responsive {
  height:auto;
  width:auto;
  overflow:scroll;
}
#AddStops .table-responsive {
  height:300px;
  overflow:scroll;
}
.btn-confirm {
  padding:0.5rem 0.5rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  font-size: 18px;
  // height: 48px;
  width: 162px;


}

.btn-AddStops {
  margin-right: 3rem;
  padding:1rem 1rem;
  height: 80%;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}

.noEditable {
  background-color: #e4e7ea;
  font-stretch: normal;
  font-style: normal;
  font-letiant: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: normal;
  text-decoration: none;
  text-transform: none;
}

</style>

